import { getRequest } from '@/core';
import { drivers } from '@/requests';

export default async function getDriversRequest() {
	let url = drivers.getPath();
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}
